var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2 6.585a3.253 3.253 0 1 0 0-6.505 3.253 3.253 0 0 0 0 6.505zm-5.84 9.381v9.83h-4.797v-9.13c0-1.976-1.24-2.91-2.786-2.91-1.76 0-2.983 1.024-2.983 3.288v8.734H.996V3.387h4.798v7.907c.863-1.186 2.462-1.96 4.583-1.96 3.234.019 5.984 2.32 5.984 6.632zm8.088-6.163h-4.799v16.011h4.799V9.803zm18.886 6.162v9.83h-4.798v-9.129c0-1.976-1.24-2.91-2.785-2.91-1.761 0-2.983 1.023-2.983 3.288v8.733H27.97V9.766h4.798v1.51c.862-1.187 2.462-1.96 4.582-1.96 3.235.036 5.984 2.337 5.984 6.65zm9.38 4.099v-5.66h3.272V9.802h-3.289V5.328l-4.798 1.438v3.037h-2.57v4.6h2.57v5.66c0 4.493 1.833 6.38 8.105 5.733v-4.348c-2.103.125-3.29 0-3.29-1.384z",
    fill: "url(#a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 32.305,
    y1: 31.599,
    x2: 31.965,
    y2: 3.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242D7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0dc2967c0a5d098c51bf4e5b6a3de3de.svg";
export { ForwardRef as ReactComponent };